import React, { Component } from "react";
import { connect } from "react-redux";
import { setActiveModel } from "../../../state/actions";
import "./modelselectortoggle.style.scss";

const MODEL_SELECTOR_TOGGLE_CLASS = "model-selector-toggle";

type Props = {
  height: number;
  toggleOverlay: () => void;
};
type States = {
  modelSelectClass: string;
};

class ModelSelectorToggle extends Component<Props, States> {
  modelSelect = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      modelSelectClass: "",
    };
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  render() {
    const { modelSelectClass } = this.state;

    return (
      <div className={`${MODEL_SELECTOR_TOGGLE_CLASS} ${modelSelectClass}`}>
        <span
          className={`${MODEL_SELECTOR_TOGGLE_CLASS}__outline`}
          onClick={() => this.props.toggleOverlay()}
        >
          Change Model
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { activeModel } = state;
  return { activeModel };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setActiveModel: (payload) => dispatch(setActiveModel(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelSelectorToggle);
